import ErrorBlock from "./error-block";

export default ErrorBlock;